import React from "react";
import { useNavigate } from "react-router-dom";
import { IBubble } from "../../Interfaces/IBubbles";
import "./BubbleGetter.css";
import { useBubbles } from "../../Providers/BubbleContext";
import Loader from "../Loader/Loader";
import { getCurrentUser } from "../../Features/LocalStorage/LocalStorageUtility";

const BubbleGetter: React.FC = () => {
  const { bubbles, loading, error } = useBubbles();
  const navigate = useNavigate();
  const user = getCurrentUser();


  if (loading) {
    return <Loader />;
  }

  const handleButtonClick = (Bubble: IBubble) => {
    if (Bubble.IsProtectedByMail && !user) {
      // Rediriger vers la page d'authentification
      navigate(`/MailCheck`);
    } else {
      // Rediriger vers la page d'information
      navigate(`/Bubble/${Bubble.Id}`);
    }
  };

  return (
    <div className="BubbleContainer">
      {error && <p>{error}</p>}

      {bubbles && bubbles?.length > 0 ? (
        bubbles?.map((bubble) => (
          <li key={bubble.Id}>
             <button 
              onClick={() => handleButtonClick(bubble)} 
              key={bubble.Id} 
              //if a bubble.IsProtectedByMail is false the bubble is always "Public". 
              //if a bubble.IsProtectedByMail is true, the bubble is concidered "public" Only if the user is not null and the user is not blocked in DB.
              className={`BubbleButton ${bubble.IsProtectedByMail ? (user && (user as any).blocked === false ? 'Public' : 'Protected') : 'Public'}`}
            >
              {bubble.Title}
            </button>
          </li>
        ))
      ) : (
        <p>Aucune bulle à afficher.</p>
      )}
    </div>
  );
};

export default BubbleGetter;
